<div class="string-count-wrapper">
  <vdw-ellipsis-label class="text" [text]="text" tooltipDisabled="true"></vdw-ellipsis-label>
  <div *ngIf="count" class="count">({{ count }})</div>
</div>
